export {
  getPageData,
  getCurrentPageData,
  getInputDataForTextClassificationPrediction,
} from './pageData/pageData';
export { parseProtoOutput } from './protoUtils/parseProtoOutput';
export { composeProtoInput } from './protoUtils/composeProtoInput';
